import React from 'react';
import './RemoveButton.css';

export const RemoveButton = ({removeGroup}) => {

    return (
        <button className={"selectedDeviceDelBtn"} onClick={()=>removeGroup()}></button>
    )
}
